import '@backstage/cli/asset-types';
import React from 'react';
import ReactDOM from 'react-dom/client';
import '@backstage/ui/css/styles.css';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
